import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Merkez Mahallesi Koltuk Yıkama", path: "/avcilar/merkez-koltuk-yikama" },
  { label: "Merkez Mahallesi Perde Yıkama", path: "/avcilar/merkez-perde-yikama" },
  { label: "Mustafa Kemal Paşa Koltuk Yıkama", path: "/avcilar/mustafa-kemal-koltuk-yikama" },
  { label: "Mustafa Kemal Paşa Yorgan Yıkama", path: "/avcilar/mustafa-kemal-yorgan-yikama" },
  { label: "Cihangir Koltuk Yıkama", path: "/avcilar/cihangir-koltuk-yikama" },
  { label: "Cihangir Yerinde Yıkama", path: "/avcilar/cihangir-yerinde-yikama" },
  { label: "Gümüşpala Koltuk Yıkama", path: "/avcilar/gumuspala-koltuk-yikama" },
  { label: "Gümüşpala Battaniye Yıkama", path: "/avcilar/gumuspala-battaniye-yikama" },
  { label: "Ambarlı Koltuk Yıkama", path: "/avcilar/ambarli-koltuk-yikama" },
  { label: "Ambarlı Perde Yıkama", path: "/avcilar/ambarli-perde-yikama" },
  { label: "Firuzköy Koltuk Yıkama", path: "/avcilar/firuzkoy-koltuk-yikama" },
  { label: "Firuzköy Kuru Temizleme", path: "/avcilar/firuzkoy-kuru-temizleme" }
];

const AvcilarServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          AVCILAR HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default AvcilarServiceArea;
